import { Vue, Component, Prop } from 'vue-property-decorator';
import cloneDeep from 'lodash/cloneDeep';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import addArea from './addArea';
import { noop } from '@/util';
import style from '@/views/components/linkForm/style.vue';

@DialogFactory
@Component({
  components: {},
  mixins: [style],
})
export default class AreaList extends IPSDialog {
  title = '区域设置';

  page = 1;

  pageSize = 10;

  totalCount = 0;

  keywords = '';

  dataList = [];

  footer = false;

  disabled = false;

  mounted() {
    this.disabled && (this.width = '800px');
    this.dataList = this.dataList.map((v, i) => {
      return Object.assign(v, { id: i });
    });
  }

  onPageChange(val) {
    this.page = val;
  }

  onPageSizeChange(val) {
    this.pageSize = val;
    this.page = 1;
  }

  onEdit(val) {
    addArea.open({ data: cloneDeep(Object.assign(val, { latAndlong: `${val.longitude},${val.latitude}` })) }).then((result) => {
      if (result.id >= 0) {
        this.dataList.splice(result.id, 1, result);
      } else {
        this.dataList.push(Object.assign(result, { id: this.dataList.length }));
      }
    }, noop);
  }

  onDel(index: number) {
    this.$confirm('确定删除该区域?', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.dataList.splice(index, 1);
        this.page = 1;
      }
    }, noop);
  }

  onClose() {
    this.$emit('result', this.dataList);
    this.$emit('hidden');
  }

  renderFooter(h) {
    return (
      <div class="bottomWrapper" style="border-top: 1px solid #EBEEF5">
        <el-button type="primary" onClick={() => this.onEdit({})}>
          添加区域
        </el-button>
        <el-button onClick={() => this.onClose()}>关闭</el-button>
      </div>
    );
  }

  renderContent(h) {
    return (
      <div class="select-list">
        <div class="tableWrapper" style="width: 100%">
          <el-table data={this.dataList.slice((this.page - 1) * this.pageSize, this.page * this.pageSize)} height="350px" tooltip-effect="light">
            <el-table-column type="selection" width="55px" align="center" />
            <el-table-column type="index" label="#" width="55" align="left" />
            <el-table-column prop="node" label="区域名称" align="left" width="240" show-overflow-tooltip={true} />
            <el-table-column
              prop="latitude"
              label="经纬度"
              align="left"
              width="250"
              {...{
                scopedSlots: {
                  default: (scoped) => {
                    return <span>{`${scoped.row.longitude},${scoped.row.latitude}`}</span>;
                  },
                },
              }}
            />
            <el-table-column prop="maxKm" label="周边距离(Km)" align="left" width="200" show-overflow-tooltip={true} />
            {!this.disabled && (
              <el-table-column
                label="操作"
                width="200"
                align="center"
                {...{
                  scopedSlots: {
                    default: (scope) => {
                      return [
                        <span class="scopeSpan" onClick={this.onEdit.bind(this, scope.row)}>
                          编辑
                        </span>,
                        <span class="scopeSpan" onClick={this.onDel.bind(this, scope.row.id)}>
                          删除
                        </span>,
                      ];
                    },
                  },
                }}
              />
            )}
          </el-table>
          <div class="bottomWrapper">
            <el-pagination
              on-size-change={this.onPageSizeChange}
              on-current-change={this.onPageChange}
              current-page={this.page}
              page-sizes={[10, 30, 60, 100]}
              page-size={this.pageSize}
              layout="total, sizes, prev, pager, next, jumper"
              total={this.dataList.length}
            />
          </div>
        </div>
        {!this.disabled && this.renderFooter(h)}
      </div>
    );
  }
}
